const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 95,
    viewBox: "0 0 452 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 205.5,
    cy: 48.5,
    r: 246.5,
    fill: "#F8D856",
    style: {
      fill: "#F8D856",
      fill: "color(display-p3 0.9725 0.8471 0.3373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189 80.8869L175.695 82.9544C179.29 79.3259 181.583 74.411 181.583 69.3412V35.2646L46.6333 56.3168V75.1256L23.1865 78.7692V81.9149L46.6333 78.2708V107.098L164.878 88.6413C167.201 88.2802 169.416 87.4544 171.43 86.2751L189 83.5448V80.8869Z",
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 108.953V130.098L143.204 107.584C148.159 106.813 152.213 102.124 152.213 97.1626V85.0371L0 108.953Z",
    fill: "#BF3DC2",
    style: {
      fill: "#BF3DC2",
      fill: "color(display-p3 0.7490 0.2392 0.7608)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.979 51.465V102.246L161.224 83.7895C170.411 82.3612 177.928 73.6765 177.928 64.4894V30.4131L42.979 51.465Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.346 77.4948L133.692 85.5217V82.8643L185.346 74.8369V77.4948Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0847 69.3991L18.335 75.266V72.1203L56.0847 66.2539V69.3991Z",
    fill: "#5959E3",
    style: {
      fill: "#5959E3",
      fill: "color(display-p3 0.3490 0.3490 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 23.1452L113 29.0121V25.8664L150.75 20V23.1452Z",
    fill: "#5959E3",
    style: {
      fill: "#5959E3",
      fill: "color(display-p3 0.3490 0.3490 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.68 12.4878L121.592 13.7446V9.33203L29.5322 23.6385V65.8705L107.7 53.7227C115.34 52.5354 121.592 45.3124 121.592 37.6717V16.2574L129.68 15.0003V12.4878Z",
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.032959 23.1413V65.373L104.046 48.3919C111.687 47.2043 117.938 39.9815 117.938 32.3408V4.00098L0.032959 23.1413Z",
    fill: "#5959E3",
    style: {
      fill: "#5959E3",
      fill: "color(display-p3 0.3490 0.3490 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5723 86.7414C68.9076 87.139 66.6286 86.6283 64.7349 85.2078C62.8414 83.7873 61.5451 81.6749 60.8463 78.8687C60.4882 77.4857 60.315 75.8145 60.3278 73.8562C60.3404 71.8976 60.6416 70.0429 61.2316 68.2917C61.8217 66.5414 62.6744 65.0223 63.7896 63.7349C65.6572 61.5719 68.0109 60.2761 70.8514 59.8482C72.5997 59.5839 74.1917 59.7229 75.6276 60.2643C77.0631 60.8065 78.2963 61.729 79.327 63.0328C80.3577 64.3369 81.095 65.8954 81.5393 67.7094C81.8559 68.9913 82.0309 70.4814 82.0639 72.1797C82.0968 73.8775 81.9062 75.5356 81.4921 77.1535C81.0777 78.7721 80.4369 80.2454 79.5702 81.5751C78.7026 82.9035 77.6045 84.0282 76.2761 84.9491C74.9469 85.8696 73.3793 86.4673 71.5723 86.7414ZM75.5136 68.6908C74.8941 65.7873 73.4982 64.4621 71.3266 64.7146C69.6516 64.9187 68.3908 65.8127 67.5434 67.3971C66.6957 68.9812 66.3309 71.1661 66.4486 73.9507C66.5157 75.6732 66.6578 76.9913 66.8753 77.9048C67.5024 80.8556 68.9109 82.1846 71.1003 81.8926C72.5389 81.7174 73.679 80.9952 74.5204 79.7246C75.3613 78.454 75.831 76.7361 75.9281 74.5705C76.0251 72.4048 75.8873 70.4449 75.5136 68.6908Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.867 70.8711L91.2358 72.5264L91.2127 83.0045L85.2134 84.0357L85.2446 57.7359L101.857 54.8809L101.849 59.7759L91.2539 61.5969L91.2464 67.6482L100.877 65.9931L100.867 70.8711Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.091 67.5669L110.461 69.2219L110.438 79.7003L104.438 80.7312L104.47 54.4314L121.082 51.5767L121.074 56.4717L110.479 58.2925L110.471 64.344L120.102 62.6889L120.091 67.5669Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.081 63.6176L129.696 65.2305L129.675 71.5186L140.779 69.6103L140.769 74.488L123.666 77.4272L123.696 51.1274L140.835 48.1821L140.828 53.0772L129.706 54.9885L129.684 60.5366L139.086 58.9205L139.081 63.6176Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.705 63.1359L149.372 63.7087L149.346 73.0137L143.347 74.0447L143.378 47.7449L152.397 46.2127C155.286 45.7164 157.627 46.0091 159.42 47.0893C161.213 48.1706 162.228 49.893 162.467 52.2577C162.655 54.126 162.386 55.7449 161.657 57.1145C160.93 58.4847 159.784 59.6645 158.22 60.6543L163.416 70.288L163.467 70.5867L157.065 71.6873L152.705 63.1359ZM149.365 58.8337L152.879 58.2659C153.839 58.101 154.632 57.7236 155.259 57.1326C155.885 56.543 156.281 55.8143 156.445 54.9468C156.609 54.0792 156.561 53.2756 156.302 52.5358C155.844 51.275 154.896 50.7319 153.457 50.9064L149.384 51.5883L149.365 58.8337Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4541 31.9342L22.228 47.0372L19.1187 47.5297L13.8093 38.5086L13.6573 48.3947L10.4571 48.9016L10.6731 33.8001L13.8026 33.3045L19.1136 42.3356L19.2539 32.4411L22.4541 31.9342ZM34.3431 42.5106L34.3018 45.1249L26.6901 46.3305L26.7313 43.7162L34.3431 42.5106ZM28.0165 31.0532L27.7905 46.1562L24.5903 46.6631L24.8063 31.5617L28.0165 31.0532ZM33.4458 36.2574L33.4119 38.7878L26.7794 39.8383L26.8234 37.3063L33.4458 36.2574ZM34.5279 30.0219L34.4882 32.6463L26.8664 33.8535L26.9161 31.2275L34.5279 30.0219ZM39.3171 42.292L42.0992 28.8227L43.7043 28.5685L44.4538 30.2297L41.4694 43.9897L39.6825 44.2727L39.3171 42.292ZM38.1823 29.4431L40.6147 42.4486L40.268 44.18L38.1884 44.5094L35.0629 29.9372L38.1823 29.4431ZM46.4644 41.1599L48.762 27.7674L52.0025 27.2542L48.9297 42.8081L46.9207 43.1263L46.4644 41.1599ZM44.8148 28.3926L47.7653 41.3368L47.4861 43.0368L45.6689 43.3246L42.5314 30.2444L43.1188 28.6612L44.8148 28.3926ZM60.9165 25.8423L63.605 32.1016L66.4992 24.9581L70.1132 24.3857L65.2542 34.9346L65.1828 40.2339L61.9221 40.7503L62.0145 35.1269L57.5464 26.3865L60.9165 25.8423ZM80.7201 35.1652L80.6789 37.7795L73.0671 38.9851L73.1084 36.3708L80.7201 35.1652ZM74.3936 23.7078L74.1675 38.8108L70.9673 39.3177L71.1833 24.2163L74.3936 23.7078ZM79.8228 28.912L79.789 31.4424L73.1565 32.4929L73.2004 29.9609L79.8228 28.912ZM80.9049 22.6765L80.8653 25.3009L73.2434 26.5081L73.2932 23.8821L80.9049 22.6765ZM88.3491 24.5295L84.5453 37.1672L81.0019 37.7284L86.5077 21.7891L88.7589 21.4325L88.3491 24.5295ZM91.2586 36.1039L87.7024 24.3008L87.386 21.65L89.506 21.3142L94.5799 35.5778L91.2586 36.1039ZM91.1592 30.5108L91.1078 33.1267L83.6576 34.3067L83.709 31.6908L91.1592 30.5108ZM96.0173 20.2829L101.329 19.452C102.226 19.3237 103.07 19.3591 103.86 19.5581C104.657 19.7494 105.313 20.1283 105.831 20.6948C106.348 21.2614 106.652 22.0446 106.741 23.0446C106.807 23.8551 106.727 24.5647 106.499 25.1734C106.276 25.7743 105.934 26.3115 105.471 26.785C105.007 27.2517 104.447 27.6852 103.793 28.0855L102.744 28.8416L97.9081 29.6074L97.9377 26.9846L101.252 26.4804C101.715 26.4001 102.122 26.2426 102.471 26.0079C102.82 25.7733 103.09 25.4752 103.281 25.1138C103.471 24.7457 103.559 24.3179 103.544 23.8304C103.541 23.4238 103.466 23.077 103.317 22.7901C103.175 22.5022 102.958 22.2915 102.668 22.1581C102.385 22.0236 102.04 21.9783 101.633 22.0221L99.1879 22.3989L99.0015 34.8775L95.8014 35.3844L96.0173 20.2829ZM103.766 34.1228L100.662 27.9191L103.901 27.3957L107.163 33.4193L107.179 33.5824L103.766 34.1228Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackground);
export default __webpack_public_path__ + "static/media/left-background.8bbd2216cab39e0649194bbbe1a21942.svg";
export { ForwardRef as ReactComponent };